import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  ariaLabel: 'Help',
  reactivateTour: 'Reactivate tour',
  help: 'Help',
};

const welsh = {
  ariaLabel: 'Cymorth',
  reactivateTour: 'Ailgychwyn y daith',
  help: 'Cymorth',
};

export const helpFloatingButtonText = getLocalizationBasedOnLang(
  english,
  welsh,
);
